// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customer-section-counts[data-v-646b7bfc]{width:100%}", "",{"version":3,"sources":["webpack://./resources/js/Components/Tools/Testing/Snapshots/CustomerSectionCounts.vue"],"names":[],"mappings":"AACA,0CACI,UAAA","sourcesContent":["\n.customer-section-counts {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
